import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "./Button.js";
import { CopyButton } from "./CopyButton.js";
import { FormDialog } from "./FormDialog.js";
/**
 * The code panel (design-spec §2 "Code panel", §4 "Code well", §5 `code-panel`): the title, the
 * code large in a tone well with Copy beside it, one sentence, and Done.
 *
 * It is informational, so it closes one way: **Done is focused, and Return and Escape are
 * Done; a click on the scrim does nothing** (§11 D6), so a stray click cannot lose a code the
 * owner has not copied yet. On the {@link FormDialog} shell, width 480 (§11 C2: the code does
 * not fit 440 at 34px). Hanken 600, letter-spaced and tabular, never mono (§11 C15).
 */
export function CodeDialog({ title, code, children, after, onDone, ...data }) {
    return (_jsxs(FormDialog, { title: title, width: 480, initialFocus: "[data-code-done]", onEscape: onDone, onEnter: onDone, "data-code-dialog": "", ...data, actions: _jsx(Button, { variant: "primary", "data-code-done": "", onClick: onDone, children: "Done" }), children: [_jsxs("div", { "data-tone-panel": "", style: {
                    display: "flex", alignItems: "center", gap: "var(--space-2)",
                    margin: "var(--space-2) 0", padding: "var(--space-2) var(--space-2) var(--space-2) var(--space-3)",
                    borderRadius: "var(--radius-panel)", background: "var(--tone)",
                }, children: [_jsx("span", { "data-code": "", style: {
                            flex: 1, minWidth: 0, color: "var(--ink-1)",
                            fontSize: "var(--type-code-size)", lineHeight: "var(--type-display-line)",
                            fontWeight: "var(--type-display-weight)", letterSpacing: "var(--type-code-tracking)",
                            fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap",
                        }, children: code }), _jsx(CopyButton, { text: code, size: "button" })] }), _jsx("p", { "data-code-sentence": "", style: {
                    margin: 0, color: "var(--ink-1)",
                    fontSize: "var(--type-body-size)", lineHeight: "var(--type-body-line)",
                }, children: children }), after !== undefined && (_jsx("div", { "data-code-after": "", style: { marginTop: "var(--space-15)" }, children: after }))] }));
}
